import { render, staticRenderFns } from "./ValueOfMitrex.vue?vue&type=template&id=5e558a59&scoped=true"
var script = {}
import style0 from "./ValueOfMitrex.vue?vue&type=style&index=0&id=5e558a59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e558a59",
  null
  
)

export default component.exports